import SectionLabel from '@/components/ui/SectionLabel'
import HoraireCard from './HoraireCard'
import { CULTES } from '@/data/cultes'
import nos_reunions from '@/assets/nos_reunions.jpeg'

export default function HorairesSection() {
  return (
    <section id="horaires" className="pt-14 pb-16 md:pt-20 md:pb-20 px-4 bg-cmp-cream">
      <div className="max-w-lg md:max-w-5xl mx-auto">
        <SectionLabel>Quand venir</SectionLabel>
        <h2 className="text-2xl md:text-3xl font-bold text-cmp-navy text-center mt-3 mb-8 md:mb-10">Nos réunions</h2>

        <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-stretch">
          <div className="bg-white rounded-lg rounded-tl-lg shadow-[0_2px_16px_rgba(15,31,92,0.08)] ring-1 ring-cmp-navy/6 divide-y divide-gray-100 overflow-hidden">
            {CULTES.map((culte) => (
              <HoraireCard key={culte.label + culte.jour} {...culte} />
            ))}
          </div>

          {/* Photo Unsplash de PRÉVISUALISATION (voir data/media.ts) — TODO: remplacer par une vraie photo de l'assemblée réunie. */}
          <div className="relative mt-6 lg:mt-0 min-h-52 rounded-lg overflow-hidden ring-1 ring-cmp-navy/6">
            <img
              src={nos_reunions}
              alt=""
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-linear-to-t from-cmp-navy-dark/70 via-transparent to-transparent" />
            <p className="absolute bottom-4 left-4 right-4 text-white text-sm font-medium">
              Toute la famille CMP, réunie chaque semaine.
            </p>
          </div>
        </div>

        <p className="text-center text-lg text-gray-400 mt-6">
          Tous les cultes durent environ 2h.
        </p>
      </div>
    </section>
  )
}
